const getGenericErrorPrefix = () => 'Uh oh. Looks like something went wrong.';

export default getGenericErrorPrefix;
